import React, { useEffect, useState,useRef  } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config';
import Pagination from '../Pagination/Paginations';
import EntriesSelector from '../Pagination/EntriesSelector';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Select from 'react-select';
import { FaEye } from "react-icons/fa";

import DataTable from 'react-data-table-component';
import { useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CreateCandidate = () => {
  const [showForm, setShowForm] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [activeStatus, setActiveStatus] = useState('Applied');
  const roleId = localStorage.getItem('role_id');
  const [hods, setHods] = useState([]);
    const [incharge, setIncharge] = useState([]);
  const [interviewType, setInterviewType] = useState('Incharge');
  const [activeMainTab, setActiveMainTab] = useState('candidates'); 
  const [searchName, setSearchName] = useState('');
  const [searchResults, setSearchResults] = useState([]);
const [searchLoading, setSearchLoading] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);
const submitLock = useRef(false);

const [isEditSubmitting, setIsEditSubmitting] = useState(false);
// candidates | report

const [reportMonth, setReportMonth] = useState(
  new Date().toISOString().slice(0, 7)
);
const [reportStatus, setReportStatus] = useState('');
const [reportData, setReportData] = useState([]);
const [reportLoading, setReportLoading] = useState(false);


 const getJobName = (jobId) => {
  if (!jobId || jobs.length === 0) return '—';

  const job = jobs.find(j => String(j.job_id) === String(jobId));
  return job ? job.job_title : '—';
};

const getEmployeeName = (empId) => {
  if (empId === null || empId === undefined) return 'No Refer';

  const id = Number(empId);
  if (id === 0 || isNaN(id)) return 'No Refer';

  const emp = employees.find(e => Number(e.employee_id) === id);
  return emp ? `${emp.first_name} (${emp.employee_id})` : 'No Refer';
};

const handleResumeDownload = (resumePath) => {
  if (!resumePath) {
    toast.error("Resume not uploaded");
    return;
  }

  // REMOVE /api from base URL
  const baseUrl = API_BASE_URL.replace('/api', '');

  const fileUrl = `${baseUrl}/${resumePath}`;
  window.open(fileUrl, "_blank");
};


  const STATUS_ORDER = ['Applied', 'Shortlisted', 'Interview', 'Recruitment', 'Hold', 'Rejected', 'Joined',];
const employeeOptions = employees.map(emp => ({
  value: emp.employee_id,
  label: `${emp.first_name} (${emp.employee_id})`
}));



  const [visibleStatuses, setVisibleStatuses] = useState([]);
 const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '31px',
    height: '31px',
    fontSize: '0.8rem', // smaller font for control
    paddingTop: '0px',
    paddingBottom: '0px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '31px',
    padding: '0 8px',
    fontSize: '0.8rem', // also reduce here
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '0.8rem', // controls the input/placeholder
    margin: '0px',
    padding: '0px',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '31px',
  }),
   menu: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
  }),
};
console.log('recruit_by:', editData.recruit_by);
console.log('matched employee:', employees.find(e => e.employee_id == editData.recruit_by));

const formatExperience = (experience, month) => {
  if (experience === 'Fresher') return 'Fresher';

  if (!experience && !month) return '—';

  const y = parseInt(experience, 10);
  const m = parseInt(month, 10);

  let text = '';

  if (!isNaN(y) && y > 0) {
    text += `${y} Year${y > 1 ? 's' : ''}`;
  }

  if (!isNaN(m) && m > 0) {
    text += `${text ? ' ' : ''}${m} Month${m > 1 ? 's' : ''}`;
  }

  return text || '—';
};




  const [candidate, setCandidate] = useState({
    job_id: '',
    first_name: '',
    last_name: '',
    dob: '',
    contact_no: '',
    gender: 'Select Gender',
    marriage_status: 'Single',
    email: '',
    address: '',
    resume_doc: null,
    refered_by: '',
    notes: '',
    qualification: '',
    experience: '',
     month: '',
    current_salary: '',
    expected_salary: '',
    created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
  });

  useEffect(() => {
    const roleId = localStorage.getItem('role_id');
    const employeeId = localStorage.getItem('employee_id');

    if (!roleId || !employeeId) {
      console.error("Missing role_id or employee_id in localStorage");
      return;
    }


    axios.get(`${API_BASE_URL}/jobs`).then(res => setJobs(res.data));
     axios.get(`${API_BASE_URL}/employees`)
    .then(res => {
      setEmployees(res.data.employees); // For interview_by, incharge, etc.
      setHods(res.data.hods);     
        
        setIncharge(res.data.incharge || []);      // For HOD dropdown
    });

   axios
  .get(`${API_BASE_URL}/job-permissions`, { params: { role_id: roleId } })
  .then(res => {
    console.log("Job permissions API response:", res.data);

    const rawStatuses = res.data
      .filter(p => String(p.role_id) === String(roleId))
      
      .map(p => p.field_name || p.job_status)  // ✅ handles both key names
      .filter(Boolean);
            console.log("roleId from localStorage:", roleId);
console.log("Permissions API response:", res.data);



    const unique = [...new Set(rawStatuses)];
    const STATUS_ORDER = ['Applied', 'Shortlisted', 'Interview', 'Recruitment', 'Hold', 'Rejected', 'Joined'];

    const sorted = STATUS_ORDER.filter(status =>
      unique.map(u => u.toLowerCase()).includes(status.toLowerCase()) // ✅ ignore case
    );

    console.log("Visible statuses:", sorted);
    setVisibleStatuses(sorted);

    if (sorted.length > 0) setActiveStatus(sorted[0]);
  })
  .catch(err => console.error("Error fetching job permissions:", err));


    // ✅ Fetch candidates
    axios.get(`${API_BASE_URL}/candidates`, {
      params: { role_id: roleId, employee_id: employeeId }
    })
      .then(res => setCandidates(res.data))
      .catch(err => console.error('Error fetching candidates:', err));
  }, []);

  useEffect(() => {
  // ❌ Do nothing if empty (VERY IMPORTANT)
  if (activeMainTab !== 'search' || searchName.trim() === '') {
    setSearchResults([]);
    return;
  }

  const delay = setTimeout(() => {
    setSearchLoading(true);

    axios
      .get(`${API_BASE_URL}/candidate-search`, {
        params: { name: searchName }
      })
      .then(res => {
        setSearchResults(res.data || []);
      })
      .catch(() => {
        toast.error("Search failed");
      })
      .finally(() => {
        setSearchLoading(false);
      });
  }, 400); // debounce

  return () => clearTimeout(delay);
}, [searchName, activeMainTab]);





  const fetchCandidates = () => {
    const roleId = localStorage.getItem('role_id');
    const employeeId = localStorage.getItem('employee_id');

    axios
      .get(`${API_BASE_URL}/candidates`, {
        params: { role_id: roleId, employee_id: employeeId  }
      })
      .then((res) => setCandidates(res.data))
      .catch((err) => console.error('Error fetching candidates:', err));
  };





  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'resume_doc') {
      setCandidate(prev => ({ ...prev, resume_doc: files[0] }));
    } else {
      setCandidate(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleEditClick = (candidate) => {
    setSelectedCandidate(candidate);
setEditData({
    ...candidate,
    job_status: candidate.job_status || 'Applied',
     month: candidate.month || '',
    refered_by: candidate.refered_by ? Number(candidate.refered_by) : 0 // ✅ FIX
  });    
    setShowEditModal(true);
  };


  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData(prev => ({ ...prev, [name]: value }));
  };



  const handleEditSubmit = async () => {

  if (isEditSubmitting) return; // 🚫 prevent double click
  setIsEditSubmitting(true);

  try {
    const errors = [];

    if (!editData.first_name) errors.push("First Name is required.");
    if (!editData.email) errors.push("Email is required.");
    if (!editData.contact_no) errors.push("Contact No is required.");
    if (!editData.job_status) errors.push("Job Status is required.");

    if (editData.job_status === "Interview") {
      if (!editData.interview_date) errors.push("Interview Date is required.");
      if (!editData.interview_time) errors.push("Interview Time is required.");
      if (!editData.interview_by) errors.push("Interview By is required.");
      if (!editData.first_level_reporting)
        errors.push("First Level Reporting is required.");
    }

    if (
      editData.job_status === "Recruitment" &&
      activeStatus !== "Hold" &&
      activeStatus !== "Interview" &&
      !editData.recruit_by
    ) {
      errors.push("Recruit By is required.");
    }

    if (editData.job_status === "Hold" && !editData.hold_by)
      errors.push("Hold By is required.");

    if (editData.job_status === "Joined") {
      if (!editData.incharge_id) errors.push("Incharge is required.");
      if (!editData.hod_id) errors.push("HOD is required.");
      if (!editData.employee_role) errors.push("Employee Role is required.");
      if (!editData.probation_days)
        errors.push("Probation Days are required.");
    }

    if (errors.length > 0) {
      errors.forEach((err, i) => setTimeout(() => toast.error(err), i * 300));
      setIsEditSubmitting(false);
      return;
    }

    const payload = {
      ...editData,
      experience: editData.experience,
      month: editData.month,
      employee_id: localStorage.getItem("employee_id"),
    };

    const response = await axios.post(
      `${API_BASE_URL}/update-candidate/${selectedCandidate.application_id}`,
      payload
    );

    toast.success(response.data.message || "Candidate updated successfully!");

    if (response.data.redirect_url) {
      setTimeout(() => {
        window.location.href = response.data.redirect_url;
      }, 1500);
      return;
    }

    setShowEditModal(false);
    setCurrentPage(1);

    const roleId = localStorage.getItem("role_id");
    const employeeId = localStorage.getItem("employee_id");

    const res = await axios.get(`${API_BASE_URL}/candidates`, {
      params: { role_id: roleId, employee_id: employeeId },
    });

    setCandidates(res.data);
    setActiveStatus(editData.job_status);
    setIsEditSubmitting(false);

  } catch (error) {
    console.log("ERROR =>", error);
    toast.error(error.response?.data?.error || "Something went wrong");

    setIsEditSubmitting(false);
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();

  if (submitLock.current) return; // 🚫 block extra clicks immediately
  submitLock.current = true;

  setIsSubmitting(true);

  const formData = new FormData();
  Object.keys(candidate).forEach(key => {
    formData.append(key, candidate[key]);
  });

  try {
    const res = await axios.post(
      `${API_BASE_URL}/create-candidate`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    toast.success(res.data.message);

    setTimeout(() => {
      window.location.reload();
    }, 1500);

  } catch (error) {
    console.log("ERROR RESPONSE:", error.response);

    toast.error(error.response?.data?.error || "Something went wrong");

    // unlock if failed
    submitLock.current = false;
    setIsSubmitting(false);
  }
};


  const filteredCandidates = candidates.filter(c => {
    const matchesStatus = c.job_status === activeStatus;
    const matchesSearch =
      c.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.job_title?.toLowerCase().includes(searchTerm.toLowerCase());
      

    return matchesStatus && matchesSearch;
  }) .sort((a, b) => new Date(b.status_changed_on || b.modified_at || b.created_at) - new Date(a.status_changed_on || a.modified_at || a.created_at))

  
  const totalPages = Math.ceil(filteredCandidates.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentCandidates = filteredCandidates.slice(indexOfFirst, indexOfLast);

const dataTableStyles = {
  rows: {
    style: {
      minHeight: '52px', // 👈 row height (default ~36px)
    },
  },
  cells: {
    style: {
      paddingTop: '8px',
      paddingBottom: '8px',
    },
  },
};

//datatable 
/* ================================
   DATATABLE COLUMNS (MEMOIZED)
================================ */
const candidateColumns = useMemo(() => [
  {
    name: 'Action',
    cell: (c) => (
      <div className="d-flex gap-2 align-items-center">
        {(c.job_status !== 'Joined') && (
          <>
            <button
             className="btn p-1"
              onClick={() => handleEditClick(c)}
              title="Edit">
  <FaEye size={16} />
</button>
            {c.resume_doc && (
              <button
                className="btn btn-link p-0"
                onClick={() => handleResumeDownload(c.resume_doc)}
                title="Download Resume">
<i className="bi bi-cloud-download fs-4 text-primary " style={{ fontSize: '16px' }}
></i></button>
            )}
          </>
        )}
      </div>
    ),
    width: '120px',
  },
  {
    name: 'Job',
    selector: row => row.job_title || '—',
    sortable: true,
  },
  {
    name: 'Name',
    selector: row => `${row.first_name} ${row.last_name}`,
    sortable: true,
  },
  {
    name: 'Referred By',
    selector: row => row.refered_by_name || 'No Refer',
    sortable: true,
  },
  {
    name: 'Email',
    selector: row => row.email,
    sortable: true,
  },
  {
    name: 'Status',
    selector: row => row.job_status,
    sortable: true,
    cell: row => (
      <span className={`badge rounded-pill text-white px-3 py-1 small fw-normal ${
        row.job_status === 'Applied' ? 'bg-danger' :
        row.job_status === 'Shortlisted' ? 'bg-success' :
        row.job_status === 'Hold' ? 'bg-warning text-dark' :
        row.job_status === 'Rejected' ? 'bg-dark' :
        row.job_status === 'Recruitment' ? 'bg-info' :
        row.job_status === 'Interview' ? 'bg-secondary' :
        row.job_status === 'Joined' ? 'bg-primary' :
        
        'bg-light text-dark'
      }`}>
        {row.job_status}
      </span>
    )
  },
 {
  name: 'Experience',
  sortable: true,
  selector: row => {
    if (!row.experience && !row.month) return '—';
    if (row.experience === 'Fresher') return 'Fresher';

    const y = parseInt(row.experience, 10);
    const m = parseInt(row.month, 10);

    let text = '';
    if (!isNaN(y) && y > 0) text += `${y} Year${y > 1 ? 's' : ''}`;
    if (!isNaN(m) && m > 0) text += `${text ? ' ' : ''}${m} Month${m > 1 ? 's' : ''}`;

    return text || '—';
  }
},

  {
    name: 'Apply Date',
    selector: row => row.created_at,
    sortable: true,
  },
  ...(activeStatus === 'Interview'
    ? [
        {
          name: 'Interview Date',
          selector: row => row.interview_date || '—',
          sortable: true,
        },
        {
          name: 'Time',
          selector: row => row.interview_time || '—',
          sortable: true,
        }
      ]
    : []
  )
], [activeStatus, employees]);
const fetchReport = async () => {
  setReportLoading(true);
  try {
    const res = await axios.get(`${API_BASE_URL}/candidate-report`, {
      params: {
        month: reportMonth,
        status: reportStatus
      }
    });

    setReportData(res.data || []);
  } catch {
    toast.error("Failed to load report");
  } finally {
    setReportLoading(false);
  }
};
const reportColumns = useMemo(() => [
  {
    name: 'Name',
    selector: row => row.name || `${row.first_name} ${row.last_name}`,
    sortable: true,
  },
  {
    name: 'Contact',
    selector: row => row.contact_no,
    sortable: true,
  },
  {
    name: 'Email',
    selector: row => row.email,
    sortable: true,
  },
  {
    name: 'Address',
    selector: row => row.address || '—',
  },
  {
    name: 'Qualification',
    selector: row => row.qualification || '—',
  },
  {
    name: 'Experience',
    selector: row =>
      row.experience
        ? `${row.experience} ${row.month ? row.month + ' Month' : ''}`
        : '—',
  },
  {
    name: 'Remark',
    selector: row => row.notes || '—',
  },
  {
    name: 'Status',
    selector: row => row.job_status,
    sortable: true,
  },
  {
    name: 'Date',
    selector: row => row.date || row.created_at,
    sortable: true,
  },
], []);







  return (
    <div className="container mt-2">
     <ToastContainer position="bottom-right" autoClose={3000} />
      <div className="d-flex justify-content-between align-items-center mb-3">
       {/* ================= TOP STATUS TABS ================= */}
<ul className="nav nav-tabs mb-3 flex-nowrap overflow-auto">
  {visibleStatuses.map(status => (
    <li className="nav-item" key={status}>
      <a
        href="#!"
        className={`nav-link ${
          activeMainTab === 'candidates' && activeStatus === status ? 'active' : ''
        }`}
        onClick={e => {
          e.preventDefault();
          setActiveMainTab('candidates');
          setActiveStatus(status);
        }}
      >
        {status}
      </a>
    </li>
  ))}

  <li className="nav-item">
    <a
      href="#!"
      className={`nav-link ${activeMainTab === 'report' ? 'active' : ''}`}
      onClick={e => {
        e.preventDefault();
        setActiveMainTab('report');
      }}
    >
      Report
    </a>
  </li>
  <li className="nav-item">
  <a
    href="#!"
    className={`nav-link ${activeMainTab === 'search' ? 'active' : ''}`}
    onClick={e => {
      e.preventDefault();
      setActiveMainTab('search');
    }}
  >
    Search
  </a>
</li>

</ul>







        {!['2', '3','6'].includes(localStorage.getItem('role_id')) && (
          <button className="btn btn-outline-secondary" onClick={() => setShowForm(!showForm)}>
  {showForm ? 'Hide Form' : 'Add Candidate'}
</button>

        )}

      </div>

{/* ================= REPORT FILTER UI ================= */}
{activeMainTab === 'report' && (
  <div className="card mb-3">
    <div className="card-header fw-bold">
      Employee Report
    </div>

    <div className="card-body row g-2 align-items-end">
      <div className="col-md-3">
        <label>Month / Year</label>
        <input
          type="month"
          className="form-control"
          value={reportMonth}
          onChange={e => setReportMonth(e.target.value)}
        />
      </div>

      <div className="col-md-3">
        <label>Status</label>
        <select
          className="form-control"
          value={reportStatus}
          onChange={e => setReportStatus(e.target.value)}
        >
          {/* <option value="">All</option> */}
          <option value="Shortlisted">Shortlisted</option>
          <option value="Interview">Interview</option>
          <option value="Recruitment">Recruitment</option>
          <option value="Hold">Hold</option>
          <option value="Rejected">Rejected</option>
          <option value="Joined">Joined</option>
        </select>
      </div>

      <div className="col-md-3">
        <button className="btn btn-primary w-100" onClick={fetchReport}>
          {reportLoading ? 'Loading...' : 'Show'}
        </button>
      </div>
    </div>
  </div>
)}
{/* ================= SEARCH BY CANDIDATE NAME ================= */}
{activeMainTab === 'search' && (
  <div className="card mb-3">
    <div className="card-header fw-bold">
      Search Candidate
    </div>

    <div className="card-body">
      <div className="row align-items-end g-3">

        <div className="col-md-4">
          <label>Candidate Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Type candidate name..."
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
        </div>

      </div>
    </div>
  </div>
)}



      {showForm && (
        <form onSubmit={handleSubmit} className="border p-4 mb-4 bg-light rounded">
          <div className="row">
           <div className="col-md-6 mb-3">
  <label>Job </label>
 <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
  name="job_id"
  value={jobs.find(j => j.job_id === candidate.job_id) || null}
  onChange={(selectedOption) =>
    setCandidate(prev => ({
      ...prev,
      job_id: selectedOption ? selectedOption.job_id : ''
    }))
  }
  options={jobs}
  getOptionLabel={option => option.job_title}
  getOptionValue={option => option.job_id}
  placeholder="Select Job"
  isClearable
  className="form-control-sm"
  classNamePrefix="react-select"
  styles={customStyles}
/>

</div>
            <div className="col-md-6 mb-3 required-tooltip">
              <label>First Name </label>
              <input type="text" name="first_name" value={candidate.first_name} onChange={handleChange} className="form-control required-input "  />
            </div>
            <div className="col-md-6 mb-3">
              <label>Last Name </label>
              <input type="text" name="last_name" value={candidate.last_name} onChange={handleChange} className="form-control required-input" />
            </div>
           <div className="col-md-6 mb-3">
  <label>Date of Birth</label>

  <DatePicker
    selected={candidate.dob ? new Date(candidate.dob) : null}
    onChange={(date) =>
      setCandidate((prev) => ({
        ...prev,
        dob: date ? date.toISOString().split("T")[0] : "",
      }))
    }
    dateFormat="yyyy-MM-dd"
    showYearDropdown
    showMonthDropdown
    dropdownMode="select"

    maxDate={new Date(
      new Date().setFullYear(new Date().getFullYear() - 18)
    )}   // ✅ ONLY 18+ allowed

    placeholderText="Select Date of Birth"
    className="form-control required-input"
  />
</div>


            <div className="col-md-6 mb-3">
              <label>Contact No </label>
              <input type="text" name="contact_no" value={candidate.contact_no} onChange={handleChange} className="form-control required-input"  />
            </div>
            <div className="col-md-6 mb-3">
              <label>Gender </label>
              <select name="gender" value={candidate.gender} onChange={handleChange} className="form-control required-input">
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label>Marital Status </label>
              <select name="marriage_status" value={candidate.marriage_status} onChange={handleChange} className="form-control required-input">
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Widowed">Widowed</option>
                <option value="Divorced">Divorced </option>

              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label>Email </label>
              <input type="email" name="email" value={candidate.email} onChange={handleChange} className="form-control required-input"  />
            </div>
            <div className="col-md-12 mb-3">
              <label>Address </label>
              <textarea name="address" value={candidate.address} onChange={handleChange} className="form-control required-input" />
            </div>
            <div className="col-md-12 mb-3">
              <label>Resume Document (PDF, DOC, DOCX)</label>
              <input
                type="file"
                name="resume_doc"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                className="form-control required-input"
              />
            </div>
           <div className="col-md-6 mb-3">
  <label>Referred By </label>

  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
  name="refered_by"
  value={
    candidate.refered_by
      ? employees.find(emp => emp.employee_id === candidate.refered_by)
      : { employee_id: 0, first_name: "No Refer" }
  }
  onChange={(selectedOption) =>
    setCandidate(prev => ({
      ...prev,
      refered_by: selectedOption ? selectedOption.employee_id : 0
    }))
  }
  options={[
    { employee_id: 0, first_name: "No Refer" },  // <---- use 0
    ...employees
  ]}
  getOptionLabel={(option) =>
    option.employee_id === 0 
      ? "No Refer"
      : `${option.first_name} (${option.employee_id})`
  }
  getOptionValue={(option) => option.employee_id}
  placeholder="Select Employee"
  isClearable
  className="form-control-sm"
  classNamePrefix="react-select"
  styles={customStyles}
/>

</div>


           
            <div className="col-md-6 mb-3">
              <label>Qualification </label>
              <input type="text" name="qualification" value={candidate.qualification} onChange={handleChange} className="form-control required-input" />
            </div>
           <div className="col-md-6 mb-3">
  <label>
    Experience 
  </label>

  <select
    name="experience"
    value={candidate.experience}
    onChange={handleChange}
    className="form-control required-input"
    required
  >
    <option value="">-- Select Experience --</option>
    <option value="Fresher">Fresher</option>

    {[...Array(10)].map((_, i) => (
      <option key={i + 1} value={i + 1}>
        {i + 1} Year{i + 1 > 1 ? 's' : ''}
      </option>
    ))}

    <option value="10+">10+ Years</option>
  </select>
</div>

<div className="col-md-6 mb-3">
  <label>Experience (Months)</label>

  <select
    name="month"
    value={candidate.month || ''}
    onChange={handleChange}
    className="form-control "
  >
    <option value="">-- Select Month --</option>

    {[...Array(11)].map((_, i) => (
      <option key={i + 1} value={i + 1}>
        {i + 1} Month{i + 1 > 1 ? 's' : ''}
      </option>
    ))}
  </select>
</div>



            <div className="col-md-6 mb-3">
              <label>Current Salary</label>
              <input type="text" name="current_salary" value={candidate.current_salary} onChange={handleChange} className="form-control required-input" />
            </div>
            <div className="col-md-6 mb-3">
              <label>Expected Salary </label>
              <input type="text" name="expected_salary" value={candidate.expected_salary} onChange={handleChange} className="form-control required-input" />
            </div>
          </div>
           <div className="col-md-6 mb-3">
              <label>Notes </label>
<textarea
  name="notes"
  value={candidate.notes}
  onChange={handleChange}
  className="form-control required-input"
  required
/>
            </div>
         <div className="text-end">
  <button
    type="submit"
    className="btn btn-primary"
    disabled={isSubmitting}
  >
    {isSubmitting ? "Submitting..." : "Submit"}
  </button>
</div>
        </form>
      )}

    {/* Top Row: Header + Entries + Search */}
    {activeMainTab === 'candidates' && (
<div className="d-flex justify-content-between align-items-center bg-white px-2 pt-2">
  <div
  className="text fw-bold"
  style={{ color: '#dc3545', fontSize: '1.25rem' }}
>
  Candidate List
</div>

  <div className="d-flex align-items-center gap-2">
    <EntriesSelector
      entriesPerPage={entriesPerPage}
      setEntriesPerPage={setEntriesPerPage}
      setCurrentPage={setCurrentPage}
    />
    <input
      type="text"
      placeholder="Search"
      value={searchTerm}
      onChange={e => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      className="form-control form-control-sm"
      style={{ width: '200px' }}
    />
  </div>
</div>
  
)}

{/* Table with no extra margin or padding */}
{activeMainTab === 'search' && searchName.trim() === '' && (
  <div className="text-center text-muted py-4">
    Type a candidate name to search
  </div>
)}


<div className="bg-white px-2 pb-2">
 <DataTable
  columns={
    activeMainTab === 'report'
      ? reportColumns
      : activeMainTab === 'search'
        ? reportColumns
        : candidateColumns
  }
  data={
    activeMainTab === 'report'
      ? reportData
      : activeMainTab === 'search'
        ? searchResults
        : currentCandidates
  }
  progressPending={searchLoading}
  pagination
  striped
  highlightOnHover
/>



</div>


     

      {showEditModal && selectedCandidate && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editData.first_name}</h5>
                <button type="button" className="btn btn-sm btn-danger" onClick={() => setShowEditModal(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                   {/* NORMAL FIELDS */}
{[
  ['First Name', 'first_name'],
  ['Last Name', 'last_name'],
  ['Email', 'email'],
  ['Contact No', 'contact_no'],
].map(([label, name]) => (
  <div key={name} className="col-md-6 mb-2">
    <label className="form-label mb-1">{label}</label>
    <input
      type="text"
      name={name}
      value={editData[name] || ''}
      onChange={handleEditChange}
      className="form-control form-control-sm required-input"
    />
  </div>
))}

{/* ✅ EXPERIENCE (READ ONLY, CONCATENATED) */}
<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Experience</label>
  <input
    type="text"
    value={formatExperience(editData.experience, editData.month)}
    readOnly
    className="form-control form-control-sm bg-light"
  />
</div>

{/* NOTES */}
<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Notes</label>
  <textarea
    name="notes"
    value={editData.notes || ''}
    onChange={handleEditChange}
    className="form-control form-control-sm required-input"
    rows={2}
  />
</div>


  


                      <div className="col-md-6 mb-2">
                        <label className="form-label mb-1">Job Status</label>
                        <select name="job_status" value={editData.job_status || ''} onChange={handleEditChange} className="form-control form-control-sm">
                          <option value="">Select Status</option>

                          {activeStatus === 'Applied' && (
                            <>
                              <option value="Shortlisted">Shortlisted</option>
                              
                              <option value="Rejected">Rejected</option>
                              <option value="Hold">Hold</option>

                            </>
                          )}

                          {activeStatus === 'Shortlisted' && (
                            <>
                              <option value="Interview">Interview</option>
                              <option value="Hold">Hold</option>
                              <option value="Rejected">Rejected</option>
                            </>
                          )}

                          {activeStatus === 'Interview' && (
  <>
    <option value="Recruitment">Recruitment</option>
    {roleId === '1' && (
      <>
        <option value="Hold">Hold</option>
        <option value="Rejected">Rejected</option>
      </>
    )}
  </>
)}


                          {activeStatus === 'Recruitment' && (
                            <>
                              <option value="Joined">Joined</option>
                              <option value="Hold">Hold</option>
                              <option value="Rejected">Rejected</option>
                            </>
                          )}

                          {activeStatus === 'Hold' && (
                            <>
                              <option value="Rejected">Rejected</option>
                                <option value="Recruitment">Recruitment</option>
                            </>
                          )}
                        </select>

                      </div>

                      {editData.job_status === 'Interview' && (
                        <>
                          <div className="col-md-6 mb-2">
  <label className="form-label mb-1">
    Interview Date
  </label>

  <DatePicker
    selected={
      editData.interview_date
        ? new Date(editData.interview_date)
        : null
    }
    onChange={(date) =>
      handleEditChange({
        target: {
          name: "interview_date",
          value: date ? date.toISOString().split("T")[0] : "",
        },
      })
    }
    dateFormat="yyyy-MM-dd"
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"
    placeholderText="Select Interview Date"
    className="form-control form-control-sm required-input"
  />
</div>

                         <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">Interview Time<span style={{color:'red'}}>*</span></label>
                            <input
                              type="time"
                              name="interview_time"
                              value={editData.interview_time || ''}
                              onChange={handleEditChange}
                              className="form-control form-control-sm"
                            />
                          </div>
                         

<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Select Type</label>
  <select
    className="form-control form-control-sm"
    value={interviewType}
    onChange={(e) => setInterviewType(e.target.value)}
  >
    <option value="Incharge">Incharge</option>
    <option value="HOD">HOD</option>
  </select>
</div>

<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Interview By</label>
  <Select
  classNames={{
    control: () => "required-select required-tooltip"
  }}
  name="interview_by"
  styles={customStyles}
  classNamePrefix="react-select"

  value={
    (interviewType === 'Incharge' ? incharge : hods).find(
      emp => String(emp.employee_id) === String(editData.interview_by)
    ) || null
  }

  onChange={selected => {
    handleEditChange({
      target: { name: 'interview_by', value: selected ? selected.employee_id : '' }
    });
  }}

  options={
    interviewType === 'Incharge'
      ? incharge
      : hods
  }

  getOptionLabel={emp => `${emp.first_name} (${emp.employee_id})`}
  getOptionValue={emp => emp.employee_id}
  placeholder={`Select ${interviewType}`}
  isClearable
/>

</div>


<div className="col-md-6 mb-2">
  <label className="form-label mb-1">First Level Reporting</label>
  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
    name="first_level_reporting"
    styles={customStyles}
    classNamePrefix="react-select"
   value={employees.find(emp => String(emp.employee_id) === String(editData.first_level_reporting)) || null}
    onChange={selected => {
      handleEditChange({
        target: { name: 'first_level_reporting', value: selected ? selected.employee_id : '' }
      });
    }}
    options={employees}
    getOptionLabel={emp => `${emp.first_name} (${emp.employee_id})`}
    getOptionValue={emp => emp.employee_id}
    placeholder="Select Employee"
    isClearable
  />
</div>

                        </>
                      )}
                     



                      {editData.job_status === 'Hold' && (
                        <>
                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">Hold By</label>
                            <select
                              name="hold_by"
                              value={editData.hold_by || ''}
                              onChange={handleEditChange}
                              className="form-control form-control-sm"
                            >
                              <option value="">Select Employee</option>
                              {employees.map(emp => (
                                <option key={emp.employee_id} value={emp.employee_id}>
                                  {emp.first_name} ({emp.employee_id})
                                </option>
                              ))}
                            </select>
                          </div>


                        </>
                      )}

                    {editData.job_status === 'Recruitment' && activeStatus !== 'Hold' && (
 <div className="col-md-6 mb-2">
  <label className="form-label mb-1">Recruit By</label>

  {editData.recruit_by ? (
    // 🔒 Show read-only once set
    <input
      type="text"
      className="form-control form-control-sm"
      value={
        employees.find(e => e.employee_id == editData.recruit_by)?.first_name +
        ` (${editData.recruit_by})` || '—'
      }
      readOnly
    />
  ) : (
    // 🧠 Automatically set recruit_by = interview_by
    <input
      type="text"
      className="form-control form-control-sm"
      value={
        employees.find(e => e.employee_id == editData.interview_by)?.first_name +
        ` (${editData.interview_by})` || '—'
      }
      readOnly
    />
  )}
</div>

)}

                      {editData.job_status === 'Joined' && (
                        <>
                         <div className="col-md-6 mb-2">
  <label className="form-label mb-1">Incharge</label>
  <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
    name="incharge_id"
    styles={customStyles}
    classNamePrefix="react-select"
    value={employees.find(emp => String(emp.employee_id) === String(editData.incharge_id)) || null}
    onChange={selected =>
      handleEditChange({
        target: { name: 'incharge_id', value: selected ? selected.employee_id : '' }
      })
    }
    options={employees}
    getOptionLabel={emp => `${emp.first_name} (${emp.employee_id})`}
    getOptionValue={emp => emp.employee_id}
    placeholder="Select Incharge"
    isClearable
  />
</div>


                          <div className="col-md-6 mb-2">
                            <label className="form-label mb-1">HOD</label>
                            <select 
  name="hod_id"
  value={editData.hod_id || ''}
  onChange={handleEditChange}
  className="form-control form-control-sm required-input"
>
  <option value="">Select HOD</option>
  {hods.map(emp => (
    <option key={emp.employee_id} value={emp.employee_id}>
      {emp.first_name} ({emp.employee_id})
    </option>
  ))}
</select>

                          </div>
<div className="col-md-6 mb-2">
  <label className="form-label mb-1">Employee Role</label>
  <select
    name="employee_role"
    value={editData.employee_role || ''}
    onChange={(e) => {
      const role = e.target.value;
      setEditData(prev => ({
        ...prev,
        employee_role: role
      }));
    }}
    className="form-control form-control-sm required-input"
  >
    <option value="">Select Role</option>
    <option value="1">Regular Employee</option>
            <option value="2">Doctor</option>
            <option value="3">House keeping</option>
            <option value="4">Security</option>
            <option value="5">Canteen</option>
            <option value="6">Intern Students</option>
  </select>
</div>


                         <div className="col-md-6 mb-2">
  <label className="form-label mb-1">Probation Days</label>
  <input
    type="number"
    name="probation_days"
    value={editData.probation_days || ''}
    min="0"                 // ✅ blocks negative input
    step="1"                // ✅ only whole numbers
    onChange={handleEditChange}
    className="form-control form-control-sm required-input"
  />
</div>

                          <div className="col-md-6 mb-2">
      <label className="form-label mb-1">Date of Joining</label>
      <input
        type="date"
        name="joined_on"
        value={editData.joined_on || ''}
        onChange={handleEditChange}
        className="form-control form-control-sm"
      />
    </div>
  </>
)}
                       

                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card shadow-sm">
                      <div className="card-header bg-primary text-white fw-bold py-2 px-3">
                        Candidate Details
                      </div>
                      <div className="card-body p-0">
                        <table className="table table-sm table-striped mb-0">
                          <tbody>
                           {[
  ['First Name', editData.first_name],
  ['Last Name', editData.last_name],
  ['Email', editData.email],
  ['Mobile', editData.contact_no],
    ['DOB', editData.dob],
    ['Gender', editData.gender],
    ['Marital Status', editData.marriage_status],

  // ['Notes', editData.notes],
['Current salary', editData.current_salary],
['Expected salary', editData.expected_salary],
['Address', editData.address],
['Job', getJobName(editData.job_id)],
['Refer By', editData.refered_by_name || 'No Refer'],
 
  ...(editData.job_status === 'Interview'
    ? [
        ['Interview Date', editData.interview_date],
        ['Interview Time', editData.interview_time],
        
        [
          'Interview By',
          employees.find(e => e.employee_id == editData.interview_by)?.first_name +
            ` (${editData.interview_by})`
        ],
        // ['Notes', editData.notes || 'j'], 
      ]
    : []),

...(activeStatus === 'Recruitment'
  ? [
      [
        'Recruit By',
        (() => {
          const emp = employees.find(e => e.employee_id == editData.recruit_by);
          return emp ? `${emp.first_name} (${emp.employee_id})` : '—';
        })()
      ],
    ]
  : []),

].map(([label, value]) => (
  <tr key={label}>
    <td className="bg-light fw-semibold" style={{ width: '40%' }}>{label}</td>
    <td>{value || <span className="text-muted">—</span>}</td>
  </tr>
))}


                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Close</button>
                {/* <button className="btn btn-primary" onClick={handleEditSubmit}>Save Changes</button> */}
            
            <button
  className="btn btn-primary"
  onClick={handleEditSubmit}
  disabled={isEditSubmitting}
>
  {isEditSubmitting ? "Saving..." : "Save Changes"}
</button>
              </div>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default CreateCandidate;